<script lang="ts" setup>
import { useRedirect, useHomeysIframe } from "@core/composables"
import { useBuildingStore } from "@core/stores/building-v2.store"
import { storeToRefs } from "pinia"

// ================================
// TYPES & INTERFACES
// ================================

type Props = {
    title: string
    icon?: string
    classHeader?: string
}

// ================================
// PROPS & EMITS
// ================================

withDefaults(defineProps<Props>(), {
    icon: "",
    classHeader: "",
})

// ================================
// COMPOSABLES
// ================================

const buildingStore = useBuildingStore()
const { redirectWrapper } = useRedirect()
const { isHomeysIframe } = useHomeysIframe()

// ================================
// ÉTAT
// ================================

/**
 * État de chargement du bâtiment depuis le store
 */
const { isFetchingBuilding } = storeToRefs(buildingStore)
</script>

<template>
    <div class="header-page-building flex flex-col gap-4">
        <BreadCrumbBuilding
            v-if="!isHomeysIframe"
            :title="title"
            :icon="icon"
            :loading="isFetchingBuilding"
            :on-navigate="redirectWrapper"
        />
        <header :class="classHeader">
            <h1 class="text-2xl font-semibold text-blue-700">
                {{ title }}
            </h1>
            <slot />
        </header>
    </div>
</template>
